// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { transpose as fn } from "../transpose.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const transpose = convertToFP(fn, 2);

// Fallback for modularized imports:
export default transpose;
